/** @format */

import { createReducer, on } from '@ngrx/store';
import {
	getProductBundleDataAction,
	getProductDataAction,
	setBopisInventory,
	setCustomProductData,
	setEDDInfo,
	setEcommInventory,
	setFBTProducts,
	setLoadingProductImages,
	setPrimaryCategory,
	setProductHasEmptyPriceAndHasPrice,
	setPromotionData,
	setResolvedSku,
	setResolvedSkuInventory,
	setSDDInfo,
	setSelectedPersonalizationOptions,
	setShippingInfo
} from './product-selection.actions';

import { ProductSelectionCoreState } from '@pdp/data-access/interfaces';

// 02 Define the initial state
export const initialProductSelectionState: ProductSelectionCoreState = {
	productStyle: {},
	bundleData: {},
	bundleProductsData: [],
	productSkus: [],
	resolvedSku: null,
	resolvedSkuInventory: {},
	ecommInventory: null,
	bopisInventory: null,
	primaryCategory: null,
	hasEmptyPriceAndHasPrice: false,
	shippingInfo: {},
	promotionData: null,
	sddInventory: null,
	eddInfo: null,
	customProductData: null,
	loadingProductImages: false,
	selectedPersonalizationOptions: {},
	FBTProducts: []
};

export const productSelectionReducers = createReducer(
	// Supply the initial state
	initialProductSelectionState,
	on(getProductDataAction, (state, { productStyle, productSkus }) => ({
		...state,
		productStyle,
		productSkus
	})),
	on(getProductBundleDataAction, (state, { bundleData, bundleProductsData }) => ({
		...state,
		bundleData,
		bundleProductsData
	})),
	on(setResolvedSku, (state, { resolvedSku }) => ({
		...state,
		resolvedSku,
		eddInfo: undefined
	})),
	on(setResolvedSkuInventory, (state, { resolvedSkuInventory }) => ({
		...state,
		resolvedSkuInventory
	})),
	on(setSDDInfo, (state, { sdd }) => ({
		...state,
		resolvedSkuInventory: { ...state.resolvedSkuInventory, sdd }
	})),
	on(setEDDInfo, (state, { eddInfo }) => ({
		...state,
		eddInfo
	})),
	on(setEcommInventory, (state, { ecommInventory }) => ({
		...state,
		ecommInventory
	})),
	on(setBopisInventory, (state, { bopisInventory }) => ({
		...state,
		bopisInventory
	})),
	on(setPrimaryCategory, (state, { primaryCategory }) => ({
		...state,
		primaryCategory
	})),
	on(setProductHasEmptyPriceAndHasPrice, (state, { hasEmptyPriceAndHasPrice }) => ({
		...state,
		hasEmptyPriceAndHasPrice
	})),
	on(setShippingInfo, (state, { shippingInfo }) => ({
		...state,
		shippingInfo
	})),
	on(setPromotionData, (state, { promotionData }) => ({
		...state,
		promotionData
	})),
	on(setCustomProductData, (state, { customProductData }) => ({
		...state,
		customProductData
	})),
	on(setLoadingProductImages, (state, { loadingProductImages }) => ({
		...state,
		loadingProductImages
	})),
	on(setSelectedPersonalizationOptions, (state, { selectedPersonalizationOptions }) => ({
		...state,
		selectedPersonalizationOptions
	})),
	on(setFBTProducts, (state, { FBTProducts }) => ({
		...state,
		FBTProducts
	}))
);

// import { createReducer, on } from '@ngrx/store';
// import {
// 	getProductBundleDataAction,
// 	getProductDataAction,
// 	setBopisInventory,
// 	setEcommInventory,
// 	setPrimaryCategory,
// 	setProductHasEmptyPriceAndHasPrice,
// 	setResolvedSku,
// 	setResolvedSkuInventory,
// 	setSDDInfo,
// 	setShippingInfo
// } from './product-selection.actions';

// // 01 Define shape of state
// export interface ProductState {
// 	productStyle: ProductStyle;
// 	bundleData: any;
// 	bundleProductsData: any;
// 	productSkus: ProductSkus[];
// 	resolvedSku: ProductSkus;
// 	resolvedSkuInventory: ResolvedSkuInventory;
// 	ecommInventory: Inventory[];
// 	bopisInventory: Inventory[];
// 	primaryCategory: string;
// 	hasEmptyPriceAndHasPrice: boolean;
// 	shippingInfo: ShippingInfo;
// 	promotionData: PromotionData;
// 	sddInventory: SddInventory;
// }

// // 02 Define the initial state
// const initialProductSelectionState: ProductState = {
// 	productStyle: {} as ProductStyle,
// 	bundleData: {},
// 	bundleProductsData: [],
// 	productSkus: [],
// 	resolvedSku: {} as ProductSkus,
// 	resolvedSkuInventory: {} as ResolvedSkuInventory,
// 	ecommInventory: [],
// 	bopisInventory: [],
// 	primaryCategory: '',
// 	hasEmptyPriceAndHasPrice: false,
// 	shippingInfo: {} as ShippingInfo,
// 	promotionData: {} as PromotionData,
// 	sddInventory: {} as SddInventory
// };

// export const productSelectionReducers = createReducer(
// 	// Supply the initial state
// 	initialProductSelectionState,
// 	on(getProductDataAction, (state, { productStyle, productSkus }) => ({
// 		...state,
// 		productStyle,
// 		productSkus
// 	})),
// 	on(getProductBundleDataAction, (state, { bundleData, bundleProductsData  }) => ({
// 		...state,
// 		bundleData,
// 		bundleProductsData
// 	})),
// 	on(setResolvedSku, (state, { resolvedSku }) => ({
// 		...state,
// 		resolvedSku
// 	})),
// 	on(setResolvedSkuInventory, (state, { resolvedSkuInventory }) => ({
// 		...state,
// 		resolvedSkuInventory
// 	})),
// 	on(setSDDInfo, (state, { sdd }) => ({
// 		...state,
// 		sddInventory: sdd
// 	})),
// 	on(setEcommInventory, (state, { ecommInventory }) => ({
// 		...state,
// 		ecommInventory
// 	})),
// 	on(setBopisInventory, (state, { bopisInventory }) => ({
// 		...state,
// 		bopisInventory
// 	})),
// 	on(setPrimaryCategory, (state, { primaryCategory }) => ({
// 		...state,
// 		primaryCategory
// 	})),
// 	on(setProductHasEmptyPriceAndHasPrice, (state, { hasEmptyPriceAndHasPrice }) => ({
// 		...state,
// 		hasEmptyPriceAndHasPrice
// 	})),
// 	on(setShippingInfo, (state, { shippingInfo }) => ({
// 		...state,
// 		shippingInfo
// 	})),
// 	on(setPromotionData, (state, { promotionData }) => ({
// 		...state,
// 		promotionData
// 	}))
// );

// export for module import
// // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
// export function productSelectionReducer(state, action) {
// 	return productSelectionReducers(state, action);
// }
